module.exports = __webpack_public_path__ + "img/MEDIA103.5c406f31.jpg";